/* ═══════════════════════════════════════════════════════
   Monmouth Cards — Homepage JS
   assets/monmouth-home.js

   - Hero countdown timer (auto-hides when past)
   ═══════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── Countdown Timer ── */
  const countdown = document.querySelector('[data-countdown]');
  if (countdown) {
    const targetDate = new Date(countdown.dataset.countdown + 'T00:00:00').getTime();
    const daysEl = countdown.querySelector('[data-days]');
    const hoursEl = countdown.querySelector('[data-hours]');
    const minsEl = countdown.querySelector('[data-mins]');

    function updateCountdown() {
      const now = Date.now();
      const diff = targetDate - now;

      if (diff <= 0) {
        countdown.hidden = true;
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minsEl) minsEl.textContent = String(mins).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 60000); // Update every minute
  }

})();
